var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { colors } from "../shared/constants";
import { withContent } from "../Content/Content";
var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  line-height: 36px;\n  height: 36px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  border-radius: 28px !important;\n  padding: 1px 24px 0;\n  text-align: center;\n  cursor: ", ";\n"], ["\n  color: ",
    ";\n  background-color: ",
    ";\n  line-height: 36px;\n  height: 36px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  border-radius: 28px !important;\n  padding: 1px 24px 0;\n  text-align: center;\n  cursor: ", ";\n"])), function (props) {
    var _a, _b, _c;
    return props.disabled
        ? colors.BATTLESHIP_GREY
        : ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.dark) || colors.PURE_BLUE;
}, function (props) {
    var _a, _b, _c;
    return props.disabled
        ? colors.DISABLED_GRAY
        : ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.light) || colors.BLUEY_GREY;
}, function (props) { return (props.disabled ? "not-allowed" : "pointer"); });
export var ButtonPrimary = withContent(function (_a) {
    var children = _a.children, theme = _a.theme, rest = __rest(_a, ["children", "theme"]);
    return (React.createElement(StyledButton, __assign({}, rest, { theme: theme }), children));
});
var templateObject_1;
